import produce from 'immer';

import type { Action } from 'Lib/reduxType';

import { STATE_LOADING, STATE_SUCCESS } from 'Store/commonActions';

import {
  LOAD_LANGUAGE,
  LOAD_LANGUAGE_SUCCESS,
  REDUCER_KEY_LANGUAGE,
  REDUCER_KEY_MESSAGE,
} from './constants';
import initialState from './initialState';
import type { I18nState } from './types';

export const reducer = produce<I18nState, [Action]>((draft, action) => {
  switch (action.type) {
    case LOAD_LANGUAGE: {
      draft[REDUCER_KEY_MESSAGE] = STATE_LOADING;
      break;
    }

    case LOAD_LANGUAGE_SUCCESS: {
      draft[REDUCER_KEY_MESSAGE] = STATE_SUCCESS;
      draft[REDUCER_KEY_LANGUAGE] = action.payload;
      break;
    }

    default:
      break;
  }
}, initialState);
